module.exports = __webpack_public_path__ + "assets/img/0602.2b21101a.png";